import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { _social_slideshow } from "../../constants/social_slideshow";

function SocialSlideshow() {
  const [slideshows, setSlideshows] = useState([]);

  useEffect(() => {
    setSlideshows(_social_slideshow);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3, // 3 items on desktop
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 992, // Tablet
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 400, // Small mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="pb-11 pb-lg-15">
      <div className="container border-top" style={{ paddingTop : "80px" }}>
        <div className="row align-items-center">
          {/* Left column: Slider */}
          <div className="col-md-8 mb-6 mb-md-0">
            <Slider {...settings}>
              {slideshows.map((slide, index) => (
                <div
                  key={index}
                >
                  <a href={slide.link} className="hover-shine d-block box" target="_blank">
                    {/* 1:1 ratio container */}
                    <div style={{ position: "relative", paddingTop: "100%" }}>
                      <img
                        src={slide.image_url}
                        alt={slide.title || "Instagram"}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          padding: "0 15px" 
                        }}
                      />
                    </div>
                  </a>
                </div>
              ))}
            </Slider>
          </div>

          {/* Right column: Instagram info */}
          <div className="col-md-4 text-center">
            <span className="d-block fs-30 text-primary lh-1">
              <i className="fab fa-instagram"></i>
            </span>
            <p className="text-primary font-weight-bold fs-30 fs-sm-40 lh-13 mb-0">
              luminit.de
            </p>
            <a href="https://www.instagram.com/luminit.de" className="lh-12">
                Folge uns auf Instagram
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialSlideshow;